import {
  CURRENT_SCROLL_POSITION,
  FETCH_USER_CHAT_SKILL_HISTORY,
  KEEP_SCROLL_POSITION,
  UPDATE_ALL_TIME_CHAT_USER_HISTORY,
  UPDATE_BUBBLE_RESPONSE,
  UPDATE_CHAT_BOUNDS,
  UPDATE_CHAT_OPEN_STATE,
  UPDATE_CHAT_POSITION,
  UPDATE_CHAT_SIZE,
  WELCOME_MESSAGE_SENT,
  SHOW_CHATBOT
} from "../actions/types";
import _ from "lodash";
import { getWholeChatConfig, storeChatConfigInStorage } from "../../common/utils";

export default function(state = {}, action) {
  let storage;
  if (
    ["UPDATE_CHAT_OPEN_STATE", "UPDATE_CHAT_SIZE", "UPDATE_CHAT_POSITION", "UPDATE_CHAT_BOUNDS"].indexOf(action.type) >=
    0
  ) {
    storage = getWholeChatConfig(action.payload.username);
  }

  switch (action.type) {
    case FETCH_USER_CHAT_SKILL_HISTORY:
      return {
        ...state,
        chatUserHistory: action.payload
      };
    case KEEP_SCROLL_POSITION:
      return {
        ...state,
        chatUserHistory: _.extend({}, state.chatUserHistory, {
          scrollPosition: action.payload,
          dateUpdated: new Date()
        })
      };
    case CURRENT_SCROLL_POSITION:
      return {
        ...state,
        chatUserHistory: _.extend({}, state.chatUserHistory, {
          currentScrollPosition: action.payload
        })
      };
    case UPDATE_CHAT_OPEN_STATE:
      storage.chat[action.payload.username].config.chatVisible = action.payload.visible;
      storeChatConfigInStorage(storage);
      return {
        ...state,
        chatVisible: action.payload
      };
    case UPDATE_ALL_TIME_CHAT_USER_HISTORY:
      return {
        ...state,
        chatUserHistory: _.extend({}, state.chatUserHistory, {
          allTimeUserHistory: action.payload
        })
      };
    case UPDATE_CHAT_SIZE:
      storage.chat[action.payload.username].config.chatSize = action.payload.size;
      storeChatConfigInStorage(storage);
      return {
        ...state,
        chatSize: action.payload
      };
    case UPDATE_CHAT_POSITION:
      storage.chat[action.payload.username].config.chatPosition = action.payload.position;
      storeChatConfigInStorage(storage);
      return {
        ...state,
        chatPosition: action.payload
      };
    case WELCOME_MESSAGE_SENT:
      return {
        ...state,
        welcomeMessageSent: action.payload
      };
    case UPDATE_BUBBLE_RESPONSE:
      return {
        ...state,
        bubbleConfig: action.payload
      };
    case UPDATE_CHAT_BOUNDS:
      storage.chat[action.payload.username].config.chatBounds = action.payload.bounds;
      storeChatConfigInStorage(storage);
      return {
        ...state,
        chatBounds: action.payload
      };
    case SHOW_CHATBOT:
      return {
        ...state,
        showChatbot: action.payload
      };

    default:
      return state;
  }
}
